import {
    Controller
} from "stimulus"
import uniqid from 'uniqid'

export default class extends Controller
{
    static targets = ['container', 'collapse', 'toggle']
    activeClass = 'mobile-nav--opened'
    transitionedClass = 'mobile-nav--transitioned'
    transitioningClass = 'mobile-nav--transitioning'
    onTransitionEnd
    onTransitionStart

    get idAttr()
    {
        return 'mobile-nav-' + this.id
    }

    get opened()
    {
        return this.element.classList.contains(this.activeClass)
    }

    get closed()
    {
        return !this.opened
    }

    initialize()
    {
        this.id = uniqid()
        this.onTransitionStart = this.handleTransitionStart.bind(this)
        this.onTransitionEnd = this.handleTransitionEnd.bind(this)
    }

    connect()
    {
        this.collapseTarget.id = this.idAttr
        this.toggleTarget.setAttribute("aria-controls", this.idAttr)
        this.toggleTarget.setAttribute("aria-expanded", false)
        this.containerTarget.classList.remove('d-none')
        this.handleTransitionEnd()
        this.listen()
        setTimeout(() => {
            this.containerTarget.classList.remove('d-none')
        }, 2000);
    }

    listen()
    {
        this.collapseTarget.addEventListener('transitionstart', this.onTransitionStart)
        this.collapseTarget.addEventListener('transitionend', this.onTransitionEnd)
    }

    handleTransitionStart()
    {
        this.element.classList.add(this.transitioningClass)
        this.element.classList.remove(this.transitionedClass)
    }

    handleTransitionEnd()
    {
        this.element.classList.remove(this.transitioningClass)
        this.element.classList.add(this.transitionedClass)
        this.containerTarget.scrollTop = 0
    }

    toggle()
    {
        if (this.opened) {
            this.close()
        } else {
            this.open()
        }
    }

    open()
    {
        this.element.classList.add(this.transitioningClass)
        this.element.classList.add(this.activeClass)
        this.toggleTarget.setAttribute("aria-expanded", true)
    }

    close()
    {
        this.element.classList.add(this.transitioningClass)
        this.element.classList.remove(this.activeClass)
        this.toggleTarget.setAttribute("aria-expanded", false)
    }

    stop()
    {
        this.collapseTarget.removeEventListener('transitionstart', this.onTransitionStart)
        this.collapseTarget.removeEventListener('transitionend', this.onTransitionEnd)
    }

    disconnect()
    {
        this.stop()
    }
}
